export default __webpack_public_path__ + "static/Connect-4203d0337ea8d1813fb98358dc05a437.png";